// extracted by mini-css-extract-plugin
export default {"info":"notify-user__info--X11kb","body":"notify-user__body--Me7M8","progress":"notify-user__progress--fUy3k"};